import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiClock } from "react-icons/fi";
import { formattedDate } from "../../../../utils/dateFormatter";

const wordsPerMinute = 210;
const getReadTime = (blog) =>
  Math.max(
    2,
    Math.ceil(
      `${blog?.content || ""} ${blog?.summary || ""}`.trim().split(/\s+/).length /
        wordsPerMinute
    )
  );

const BlogCard = ({ blog, featured = false }) => {
  const category =
    blog?.category?.name || blog?.category || blog?.topic || "Market Insights";

  return (
    <article className={`blog-card ${featured ? "blog-card-featured" : ""}`}>
      <Link to={`/blogs/${blog.slug || blog._id}`} className="blog-card-image">
        <img src={blog.thumbnail} alt="" loading={featured ? "eager" : "lazy"} />
        {featured && <span>Featured story</span>}
      </Link>
      <div className="blog-card-body">
        <div className="blog-card-meta">
          <span>{category}</span>
          <time dateTime={blog.createdAt}>{formattedDate(blog.createdAt)}</time>
          <span><FiClock /> {getReadTime(blog)} min read</span>
        </div>
        <Link to={`/blogs/${blog.slug || blog._id}`}>
          <h3>{blog.title}</h3>
        </Link>
        <p>
          {blog.summary?.length > (featured ? 240 : 145)
            ? `${blog.summary.slice(0, featured ? 240 : 145)}…`
            : blog.summary}
        </p>
        <Link className="blog-read-link" to={`/blogs/${blog.slug || blog._id}`}>
          Read article <FiArrowUpRight />
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;
